var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec5Cardimg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 57,
    viewBox: "0 0 63 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9082,
    cy: 37.0439,
    r: 0.945263,
    fill: "#102C57"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0507,
    cy: 42.7153,
    r: 0.945263,
    fill: "#102C57"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0839,
    cy: 45.0786,
    r: 0.945263,
    fill: "#102C57"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7929,
    cy: 37.0439,
    r: 0.945263,
    fill: "#102C57"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1562,
    cy: 29.009,
    r: 0.945263,
    fill: "#102C57"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7929,
    cy: 20.9743,
    r: 0.945263,
    fill: "#102C57"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.121,
    cy: 15.3027,
    r: 0.945263,
    fill: "#102C57"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0507,
    cy: 15.3027,
    r: 0.945263,
    fill: "#102C57"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9082,
    cy: 20.9743,
    r: 0.945263,
    fill: "#102C57"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.121,
    cy: 43.1879,
    r: 0.945263,
    fill: "#102C57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 29.0091C2 29.0091 5.60072 29.0091 7.9079 29.0091M15.47 29.0091C15.3395 18.1764 24.0153 9.28904 34.8479 9.15852C45.8102 9.02645 54.6336 18.0461 54.6984 29.0091C54.7637 40.0375 45.8765 49.0959 34.8479 49.0959C21.3779 49.0959 15.47 37.7527 15.47 29.0091ZM15.47 29.0091H7.9079M7.9079 29.0091C8.35612 34.237 10.0138 38.9693 12.6242 42.9516M7.9079 29.0091C7.9469 26.6278 8.31814 24.2385 9.00493 21.9195M12.6242 42.9516C17.3835 50.212 25.3097 54.9796 34.8479 55.7127C36.5893 55.8466 39.3164 55.7138 39.3378 55.7127C39.3384 55.7127 39.338 55.7123 39.3381 55.7118L40.0467 52.1689C40.0468 52.1683 40.0472 52.1679 40.0478 52.1678C43.3516 51.7527 45.0762 51.1395 47.6081 48.624C47.6086 48.6236 47.6093 48.6235 47.6098 48.624L50.4438 50.9856C50.4444 50.986 50.4451 50.986 50.4456 50.9855L56.8245 44.6066C56.8249 44.6062 56.825 44.6055 56.8247 44.605L54.699 41.5345C54.6986 41.5341 54.6987 41.5334 54.699 41.533C56.6789 39.0994 57.4261 37.4416 57.7704 33.7362C57.7705 33.7357 57.7708 33.7352 57.7713 33.7351L61.5507 32.554C61.5512 32.5539 61.5516 32.5534 61.5516 32.5528V23.575C61.5516 23.5743 61.551 23.5737 61.5503 23.5737H57.7716C57.771 23.5737 57.7705 23.5733 57.7703 23.5727C57.2182 20.2719 56.4243 18.7505 54.6988 16.2485C54.6986 16.2482 54.6985 16.2477 54.6987 16.2473L56.3523 12.4678C56.3525 12.4672 56.3524 12.4667 56.3519 12.4663L50.4454 7.26855C50.445 7.26819 50.4444 7.26813 50.4439 7.2684L47.1371 9.15809C47.1366 9.15835 47.136 9.1583 47.1356 9.15798C44.7073 7.22194 43.1006 6.59508 40.0477 5.85025C40.0472 5.85013 40.0468 5.84974 40.0467 5.84924L39.3381 2.06998C39.338 2.0694 39.3375 2.06898 39.3369 2.06894C26.7849 1.31313 17.5201 6.85542 12.4161 14.5937M12.6242 42.9516H2M2 35.6258H8.85316M9.00493 21.9195H2M9.00493 21.9195C9.76401 19.3565 10.9086 16.8793 12.4161 14.5937M2 14.5937H12.4161M19.0147 29.0091C19.0147 29.0091 26.5042 29.0091 31.3032 29.0091M31.3032 29.0091C31.3032 31.3722 32.6856 33.2627 34.8479 33.2627C36.4411 33.2627 37.6794 32.1254 38.1704 30.6632M31.3032 29.0091C31.3032 27.7777 31.9483 26.5463 32.9574 25.8374M37.9826 27.3548C38.2164 27.8601 38.3584 28.4236 38.3926 29.0091C38.4259 29.5772 38.3458 30.1409 38.1704 30.6632M37.9826 27.3548H46.1911C46.1911 27.3548 46.1911 27.3548 46.1911 27.3548C46.1911 27.3548 47.1363 27.3548 47.3726 28.7727C47.6086 30.1884 46.1953 30.6618 46.1911 30.6632C46.1909 30.6633 46.191 30.6632 46.1908 30.6632H38.1704M37.9826 27.3548C37.6625 26.6627 37.1703 26.08 36.5475 25.7006M36.5475 25.7006C36.0556 25.4009 35.4823 25.228 34.8479 25.228C34.1422 25.228 33.4976 25.4578 32.9574 25.8374M36.5475 25.7006V14.3575C36.5475 14.3574 36.5475 14.3575 36.5475 14.3574C36.5476 14.356 36.7377 12.4669 34.8479 12.4669C32.9574 12.4669 32.9574 14.3574 32.9574 14.3574C32.9574 14.3574 32.9574 14.3574 32.9574 14.3574V25.8374",
    stroke: "#102C57",
    strokeWidth: 2.36316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec5Cardimg4);
export default __webpack_public_path__ + "static/media/sec5cardimg4.a6a7a3bb426358f553eb2840bbab0464.svg";
export { ForwardRef as ReactComponent };